<sura-admin [linkActive] = "linkActive"></sura-admin>
<div class="container  pl-0 pr-0">
    <div style="padding: 10px 0px"></div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
        <div class="card-header">
           Administraci&oacute;n de Asistencias
        </div>
        <form action="" class="card-body pr-0 pl-0">
           <div class="row justify-content-center">
                <div class="col-6">
	                <mat-label class="col-md-3 col-12 col-form-label lbl-srua-label">Nro. Asamblea:</mat-label>
	                <mat-form-field class="col-md-9 col-12" appearance="outline">
	                    <input matInput placeholder="" name="asamblea"
	                        [formControl]="nroAsambleaValidacion" [(ngModel)]="newAsamblea.id" required maxlength="6" (keypress) = "fnKeyDownNumeric($event)" (keyup) = "fnNumericMobile($event)"  (input)="fnInputMaxLength($event);" (change)="changeAsamblea()">
	                    <mat-error *ngIf="nroAsambleaValidacion.invalid">{{getErrorMessageNroAsamblea()}}</mat-error>

	               </mat-form-field>
	            </div>

	            <div class="col-2 text-left pl-0 pt-4 pt-md-0 content-btn padding-top-butons-sura">
	            	<button mat-mini-fab color="primary" [disabled]="nroAsambleaValidacion.invalid" matSuffix   aria-label="Clear"
	                        (click)="buscarAsamblea()" matTooltip="Buscar Asamblea">
	                        <mat-icon>search</mat-icon>
                    </button>
	            </div>

	            <div class="percentage-right">
	            	<div class="percentage-asistencia">{{porcentaje}} %</div>
	            	<span class="quorum">QU&Oacute;RUM</span>
	            </div>
	            <div class="col-4">
	            </div>
            </div>
            <div class="row justify-content-start">
             	<div class="col-6">
	               <mat-label class="col-md-3 col-12 col-form-label" style="margin-right:7px">Organizador:</mat-label>
	              <mat-form-field class="col-md-9 col-12" appearance="outline">
	                <input matInput disabled="disabled" value="{{newAsamblea.organizador.descripcion}}">
	              </mat-form-field>
	              </div>
            </div>
        </form>
        <mat-divider></mat-divider>
        <div class="row justify-content-start">
            <div class="col-8"></div>
            <div mat-dialog-actions class="d-flex justify-content-end mt-2 pr-2 padding-bottom-10">
                <button mat-raised-button color="primary" [disabled]="disabledBtnExcel" [matMenuTriggerFor]="menu" ><mat-icon>cloud_download</mat-icon> &nbsp;&nbsp;Generar Reporte</button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="ExportTOExcel()" >Asistencia</button>
                  <button mat-menu-item (click)="exportReportDetail(0)">Detalle</button>
                  <button mat-menu-item (click)="exportReportDetail(1)">Detalle Historico</button>
                  <button mat-menu-item (click)="ExportToPDF()">Asistencia (PDF)</button>
                </mat-menu>
            </div>

             <div mat-dialog-actions class="d-flex justify-content-end mt-2 pr-2 padding-bottom-10">
                        <button mat-raised-button color="primary" (click)="openRegistroAsistente()" [disabled]="disableBtnAgregar"><mat-icon>person_add</mat-icon> &nbsp;&nbsp;Registrar Asistencia</button>
            </div>
        </div>

        <div class="mat-elevation-z4">
            <div class="example-container " #TABLE>
                <table mat-table #table [dataSource]="dataSource" aria-describedby="tabla administracion de asistencias">
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="VOTA" sticky>
                        <th mat-header-cell *matHeaderCellDef scope="col">VOTA</th>
                        <td mat-cell *matCellDef="let row; let i = index"  matTooltip="{{newAsamblea.estado == '0' || row.id <= 0 ? '' : 'Activa/Desactiva votante'}}">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? toggleCheckVoto(row, i) : null"
                                [checked]="selection.isSelected(row)"
                                [disabled]="newAsamblea.estado == '0' || row.id <= 0 || row.tipo == 'Representante'">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="TIPO" >
                        <th mat-header-cell *matHeaderCellDef scope="col"> TIPO </th>
                        <td mat-cell *matCellDef="let element" class="text-center">{{element.tipo}}</td>
                    </ng-container>

                    <ng-container matColumnDef="NUMERODOCUMENTO" >
                        <th mat-header-cell *matHeaderCellDef scope="col"> NRO. DOCUMENTO </th>
                        <td mat-cell *matCellDef="let element" class="text-center">{{element.tipoDocumento}}&nbsp;{{element.numeroDocumento}}</td>
                    </ng-container>

                    <ng-container matColumnDef="TITULAR">
                        <th mat-header-cell *matHeaderCellDef scope="col"> TITULAR </th>
                        <td mat-cell *matCellDef="let element" class="text-left">{{element.nombres}}&nbsp;{{element.apellidos}}</td>
                    </ng-container>

                    <ng-container matColumnDef="REPRESENTANTE">
                        <th mat-header-cell *matHeaderCellDef scope="col"> REPRESENTANTE </th>
                        <td mat-cell *matCellDef="let element" class="text-left"> {{element.representante.descripcion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA HORA">
                        <th mat-header-cell *matHeaderCellDef scope="col"> FECHA HORA </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{ element.fechaRegistro | date : "yyyy-MM-dd HH:mm" }} </td>
                    </ng-container>

                    <ng-container matColumnDef="OPCIONES">
                        <th mat-header-cell *matHeaderCellDef scope="col">OPCIONES</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                        <p>
                          <button *ngIf="!(loadingBorrar >= 0 && loadingBorrar === element.index)" matTooltip="Eliminar asistencia" mat-icon-button color="primary" type="button" (click)="showEliminarAsistente(element)" [disabled]="disableBtnEliminar || element.id == '0'">
                            <mat-icon aria-label="icon-button with a heart icon">delete</mat-icon>
                          </button>
                          <button *ngIf="loadingBorrar >= 0 && loadingBorrar === element.index" type="button" mat-icon-button color="primary" [disabled]="true" >
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </button>
                          <button *ngIf="!(loading >= 0 && loading === element.index)" [matTooltip]="element.id == '0' ? 'Registrar asistencia' : ''" mat-icon-button [color]="element.id == '0' ? 'gray' : 'green'" type="button" (click)="element.id == '0' ? registrarAsistenteInline(element) : '' " >
                            <mat-icon aria-label="icon-button with a heart icon">check_circle</mat-icon>
                          </button>
                          <button *ngIf="loading >= 0 && loading === element.index" type="button" mat-icon-button color="primary" [disabled]="true" >
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </button>
                        </p>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                    </tr>
                </table>
            </div>

            <div *ngIf="dataSource.data.length === 0" class="text-center text-secondary p-3">
                <span>No se encontraron resultados</span>
            </div>
            <mat-divider></mat-divider>
            <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>

